/**
 * Convert a short form (#abc) to long form (#aabbcc).
 *
 * Set withHash to false to omit the leading # from the returned hex string.
 */
export function shortToLongHex(hex, withHash = true) {
	if (hex.length >= 6) return hex;
	return (
		(withHash ? '#' : '') +
		hex
			.match(/[a-f0-9]{1}/gi)
			.map(v => v.repeat(2))
			.join('')
	);
}

/**
 * Converts a given hex color string e.g. 'FFFFFF' or '#FFFFFF' or '#FFF'
 * to a string containing the rgb values split by commas e.g. 255,255,255
 */
export function hexToRgb(hex) {
	return shortToLongHex(hex, false)
		.match(/[a-f0-9]{2}/gi)
		.map(v => parseInt(v, 16))
		.join(',');
}
